import React, { useCallback } from "react";
//#region types
import { DialogEnums } from "models/enums";
import { FileItem } from "models/utilTypes/fileUtilsTypes";
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import ImageZoom from "./imageZoom";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function useImageZoom(images: FileItem[], getImageContent: (id: string | number) => Promise<string | undefined>) {
  const getZoomImageDialog = useCallback(
    (index: number): DialogProps => ({
      isOpen: false,
      title: "",
      dialogType: DialogEnums.DialogType.ImageZoom,
      className: cssExports.transparent,
      children: (
        <ImageZoom
          imageZoomListItems={images}
          currentPreviewIndex={index}
          getImageContent={getImageContent}
        ></ImageZoom>
      ),
    }),
    [images]
  );

  return getZoomImageDialog;
}

export default useImageZoom;
